import { GET_EVENTS_SUCCESS, GET_EVENTS_FAILURE, GET_EVENTS_REQUESTED } from './events.constants'
import API from './events.api'
import { AppThunk } from '../../../root.reducer'

export const getEvents = (contactId: $TSFIXME): AppThunk => {
  return async dispatch => {
    dispatch(getEventsRequested())
    try {
      const events = await API.getEvents(contactId)

      dispatch(getEventsSuccess(events))
    } catch (error) {
      dispatch(getEventsFailure(error))
    }
  }
}

export const getEventsRequested = () => ({
  type: GET_EVENTS_REQUESTED,
}) as const

export const getEventsSuccess = (data: $TSFIXME[]) => ({
  data,
  type: GET_EVENTS_SUCCESS,
}) as const

export const getEventsFailure = (error: $TSFIXME) => ({
  error,
  type: GET_EVENTS_FAILURE,
}) as const

export type EventsAction = ReturnType<
  | typeof getEventsRequested
  | typeof getEventsSuccess
  | typeof getEventsFailure
>
